import { ComboboxOption } from 'ui';

export function filterEnumOpts<Option extends ComboboxOption>(
  opts: Option[],
  search: string,
): Option[] {
  return !search
    ? opts
    : opts.filter((opt) =>
        opt.label.toLowerCase().trim().includes(search.toLowerCase().trim()),
      );
}
